import { z } from 'zod';

import { ProbationReviewAuditAction, ProbationReviewAuditOperation } from '@/common/graphql';

import { IsoDateFilter } from './iso-date';

/** The filter of the audit log screen (FR-034): who it is about, who did it, what, and when. */
export const ProbationReviewAuditLogFilter = z.object({
  page: z.number().catch(1),
  // The employee the entries are about; set by the History control of a list row (FR-033).
  employeeId: z.string().nullable().optional().catch(null),
  actingEmployeeId: z.string().nullable().optional().catch(null),
  actions: z.array(z.nativeEnum(ProbationReviewAuditAction)).catch([]),
  tableNames: z.array(z.string()).catch([]),
  operations: z.array(z.nativeEnum(ProbationReviewAuditOperation)).catch([]),
  changedFrom: IsoDateFilter,
  changedTo: IsoDateFilter,
});
export type ProbationReviewAuditLogFilterType = z.infer<typeof ProbationReviewAuditLogFilter>;
